// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SbpInvoiceCidAPIModel
 */
export interface SbpInvoiceCidAPIModel {
    /**
     * 
     * @type {string}
     * @memberof SbpInvoiceCidAPIModel
     */
    partnerId: string;
    /**
     * 
     * @type {string}
     * @memberof SbpInvoiceCidAPIModel
     */
    cid: string;
    /**
     * 
     * @type {string}
     * @memberof SbpInvoiceCidAPIModel
     */
    allocationToken: string;
}

export function SbpInvoiceCidAPIModelFromJSON(json: any): SbpInvoiceCidAPIModel {
    return SbpInvoiceCidAPIModelFromJSONTyped(json, false);
}

export function SbpInvoiceCidAPIModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): SbpInvoiceCidAPIModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'partnerId': json['partnerId'],
        'cid': json['cid'],
        'allocationToken': json['allocationToken'],
    };
}

export function SbpInvoiceCidAPIModelToJSON(value?: SbpInvoiceCidAPIModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'partnerId': value.partnerId,
        'cid': value.cid,
        'allocationToken': value.allocationToken,
    };
}


